// Root mutations
import _ from 'underscore'
import { map, uniqBy, filter, indexOf } from 'lodash'
export default {
  survey: state => {
    return state.survey
  },

  getSections: (state, getters) => {
    return map(uniqBy(store.state.survey.survey.statement_surveys, 'capability_section'), section => ({
      id: section.capability_section,
      name: section.capability_section_name,
      statements: filter(store.state.survey.survey.statement_surveys, { capability_section: section.capability_section })
    }))
  },

  getCurrentSection: (state, getters) => {
    const { pointers } = state
    const { getSectionByIndex } = getters
    const getCurrentSection = getSectionByIndex(pointers.section)
    console.log('getCurrentSection', getCurrentSection)
    return getCurrentSection
  },

  getCurrentStatement: (state, getters) => {
    const { getCurrentSection } = getters
    const { pointers } = state
    const getCurrentStatement = getCurrentSection ? getCurrentSection.statements[pointers.statement] : null
    console.log('getCurrentStatement', getCurrentStatement)
    return getCurrentStatement
  },

  getCurrentStatementIdx: (state, getters) => {
    const { pointers } = state
    console.log('getCurrentStatementIdx', pointers.statement)
    return pointers.statement
    // const { getCurrentSection } = getters
    // const getCurrentStatementIdx = getCurrentSection ? indexOf(getCurrentSection.statements, getCurrentSection.statements[pointers.statement]) : null //TODO korektni hack
    // return getCurrentStatementIdx
  },

  getCurrentSectionIdx: (state, getters) => {
    const { pointers } = state
    console.log('getCurrentSectionIdx', pointers.section)
    return pointers.section
    // const { getSections } = getters
    // const getCurrentSectionIdx = getSections ? indexOf(getSections, getSections[])
    // return getCurrentSectionIdx
  },

  getSectionByIndex: (state, getters) => index => {
    const { getSections } = getters
    const getSectionByIndex = getSections[index]
    console.log('getSectionByIndex', index, getSectionByIndex)
    return getSectionByIndex
  },

  isLastSection: (state, getters) => {
    const { pointers } = state
    const { getSectionByIndex } = getters
    const isLastSection = !getSectionByIndex(pointers.section + 1)
    console.log('isLastSection', isLastSection)
    return isLastSection
  },

  isFirstStatement: (state) => {
    const { pointers } = state
    const isFirstStatement = pointers.statement == 0
    console.log('isFirstStatement', isFirstStatement)
    return isFirstStatement
  },

  isSectionEnd: (state, getters) => {
    const { pointers } = state
    const { getCurrentSection } = getters
    const isSectionEnd = getCurrentSection ? pointers.statement == getCurrentSection.statements.length : false
    console.log('isSectionEnd', isSectionEnd)
    return isSectionEnd
  },

  isSectionStart: (state, getters) => {
    const { pointers } = state
    const isSectionStart = pointers.statement == -1
    console.log('isSectionStart', isSectionStart)
    return isSectionStart
  },

  isSurveyStart: (state, getters) => {
    const { pointers } = state
    const isSurveyStart = pointers.section == -1 && pointers.statement == -1
    console.log('isSurveyStart', isSurveyStart)
    return isSurveyStart
  },

  getResults: (state, getters) => {
    const { pointers } = state
    const { getCurrentSection } = getters
    const getResults = getCurrentSection ? _.map(_.groupBy(_.sortBy(getCurrentSection.statements, 'category_sequence'), 'capability_section_name'), (value, key) => ({[key]: _.groupBy(_.sortBy(value, 'capability_sequence'), 'capability_name')})) : {}
    console.log('getResults', getResults)
    return getResults
  },

  canDisplaySectionResults: (state, getters) => {
    return state.canDisplaySectionResults
  },

  pusher: (state, getters) => {
    return state.pusher
  }
}